import React from 'react';
import { string } from 'prop-types';
import { Table } from 'semantic-ui-react';

const PatientItem = ({ label, value }) => (
  <Table.Row>
    <Table.Cell>{label}</Table.Cell>
    <Table.Cell>{value}</Table.Cell>
  </Table.Row>
);

PatientItem.propTypes = {
  label: string,
  value: string,
};
PatientItem.defaultProps = {
  label: '',
  value: '',
};

export default PatientItem;
